export const snowflakeAccountsPath = (tenantId: string, accountId: string) =>
  `o/${tenantId}/integrations/snowflake/account/${accountId?.toUpperCase()}`;
